<template>
  <div class="sm-group-forwarding">
    <template v-if="(curItem && curPMB)">
      <div class="sm-wrap sm">
        <breadcrumbs-block :crumbs="isGroup ? breadcrumbsGroup : breadcrumbsSingle" />
        <template v-if="!finishForward">
          <h2>Forward {{isGroup ? 'Group ' : ''}}Mail #{{isGroup ? curItem.id : curItem.mail_number}}</h2>

          <div class="sm-group-forwarding__customer-aside">
            <div class="sm-group-forwarding__customer-aside--top">
              <ul class="sm-customer-aside-list">
                <li
                  v-if="curItem.is_forward_requested"
                  class="sm-customer-aside-list__item delimiter"
                >
                  <span class="sm-customer-aside-list__item--cust">Status</span>
                  <span
                    v-if="curItem.status_label.toLowerCase().includes('expedited')"
                    class="urgent"
                  >
                    <span>Expedited forward requested&nbsp;</span>
                    <span v-if="curItem.delivery_days">({{curItem.delivery_days == 1 ? 'next day delivery' : curItem.delivery_days + ' delivery days'}})</span>
                  </span>
                  <span
                    v-else
                    class="req"
                  >Forward requested</span>
                </li>
                <li class="sm-customer-aside-list__item">
                  <span class="sm-customer-aside-list__item--cust">{{provider.client_level != 1 ? 'Customer' : 'User'}}</span>
                  <a 
                    href="#" 
                    class="sm-customer-aside-list__item--cust-name sm-link sm-txt-strong"
                    @click.prevent="$router.push(`/admin/customer/${curItem.account_id}`)"
                  >{{curPMB.name}}</a>
                </li>

                <li class="sm-customer-aside-list__item">
                  <span class="sm-customer-aside-list__item--qty">Qty.</span>
                  <span class="sm-customer-aside-list__item--qty-num sm-txt-strong">{{!isGroup ? curItem.quantity : 1}}</span>
                </li>
              </ul>
            </div>

            <div class="sm-group-forwarding__customer-aside--bottom 
                        sm-aside-hide-bottom"
            >
              <ul class="sm-price-aside-list">
                <li class="sm-price-aside-list__item">
                  <span>SphereMail Fee</span>
                  <span class="sm-price-aside-list__item--fee-price">
                    {{formatPrice(service_fee * quantity)}}
                  </span>
                </li>

                <li class="sm-price-aside-list__item">
                  <span>Delivery</span>
                  <span class="sm-price-aside-list__item--delivery-price">
                    {{formatPrice(deliveryPrice)}}
                  </span>
                </li>

                <li class="sm-price-aside-list__item">
                  <span class="sm-h5">Total to pay</span>
                  <span class="sm-h5 sm-price-aside-list__item--total-price">
                    {{formatPrice(totalPrice)}}
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <mail-forwarding-addresses
            :curFwAddress="curFwAddress"
            :curPMB="curPMB"
            :noForm="noForm"
            :multipleAddresses="forwardingAddresses.length > 1"
            :country="curCountry"
            @show-selected="showSelectAddr"
            @open="$event => openPopup($event)"
          />

          <template v-if="Object.keys(curFwAddress).length">
            <h4
              v-if="isDifferentCountry && !deliveryServices.length"
            >
              Currently there are no shipping carriers available for your country ({{curCountry.name}}). You can use manual forward option.
              <!--For all international shippings we only support SphereMail carriers rate, but if you are outside of USA you always will have the manual forward option.--></h4>
            <template v-else>
              <div class="sm-group-forwarding__carrier
                          sm-group-forwarding__bottom-gap 
                          sm-group-forwarding__bottom-gap--line
                          sm-style-flex"
              >
                <h5 class="sm-group-forwarding__title">Carrier</h5>
                <div class="sm-radiobutton-block">
                  <radiobutton-block 
                    v-for="service in deliveryServices"
                    :key="service.id"
                    :class="{
                      'delivery-logo': true,
                      [`delivery-logo-${service.id}`]: true,
                      'disabled': service.disabled,
                      'active': curService == service
                    }"
                    :text="service.label" 
                    :description="(service.disabled ? service.message_when_disabled : service.message_for_the_user) || ''"
                    :name="`carrier`"
                    :checked="curService == service"
                    @input="curService = service" 
                  />
                </div>
              </div>
              <div 
                class="
                  sm-group-forwarding__label
                  sm-group-forwarding__bottom-gap 
                  sm-group-forwarding__bottom-gap--line
                  sm-style-flex
                "
              >
                <h5 class="sm-group-forwarding__title">Label format</h5>
                <div class="sm-radiobutton-block" >
                  <radiobutton-block 
                    v-for="size in labelSizes"
                    :key="size.value"
                    :class="{
                      'active': curLabelSize == size.value
                    }"
                    :text="size.name" 
                    :description="size.desc"
                    :name="`labelSize`"
                    :checked="curLabelSize == size.value"
                    @input="curLabelSize = size.value" 
                  />
                </div>
              </div>

              <mail-forwarding-packaging
                :item="curItem"
                :service="curService"
                @package="curPackage = $event"
              />

              <btn-block 
                v-if="!isDifferentCountry"
                :type="'small'"
                :text="'Find rates'"
                :class="'sm-group-forwarding__find-rates'"
                @click="findDeliveryOptions"
              />

              <mail-forwarding-details
                v-if="isDifferentCountry"
                @find-rates="findInternationalRates($event)"
              />

              <div 
                v-if="deliveryOptions.length"
                class="sm-group-forwarding__delivery"
              >
                <h5>Delivery option</h5>
                <ul class="sm-group-forwarding__delivery-list">
                  <li
                    v-for="item in deliveryOptions"
                    :key="item.id"
                    class="sm-group-forwarding__delivery-list-item"
                    @click="selectedOption = item"
                  >
                    <div class="sm-group-forwarding__delivery-list-item-flex">
                      <radiobutton-block
                        :name="`delivery_option`"
                        :text="`${item.carrier} ${item.service}`"
                        :checked="selectedOption == item"
                      />
                      <span class="sm-txt-strong sm-sys">{{item.rate}}</span>
                    </div>

                    <p v-if="item.delivery_date">Delivered on or before {{item.delivery_date | moment('dddd, MMMM D, YYYY')}}</p>
                    <p v-else-if="item.delivery_days">Delivered in {{item.delivery_days}} day{{item.delivery_days > 1 ? 's' : ''}}</p>
                    <p v-else-if="item.est_delivery_days">Delivery estimate {{item.est_delivery_days}} day{{item.est_delivery_days > 1 ? 's' : ''}}</p>

                    <span v-if="selectedOption == item">
                      <include-svg :name="'icon-note'" />
                      <span class="sm-small">All orders are subject to SphereMail charges, in amount of {{formatPrice(service_fee * quantity)}}</span>
                    </span>
                  </li>
                </ul>
              </div>
              <div 
                v-else-if="ratesRequested"
                class="sm-group-forwarding__delivery"
              >
                <h4>No delivery options for selected Carrier/Package type. Please select other options to find rates</h4>
              </div>
            </template>
          </template>

          <div class="sm-group-forwarding__customer-aside 
                      sm-aside-hide-small"
          >
            <div class="sm-group-forwarding__customer-aside--bottom">
              <ul class="sm-price-aside-list">
                <li class="sm-price-aside-list__item">
                  <span>SphereMail Fee</span>
                    <span class="sm-price-aside-list__item--fee-price">
                      {{formatPrice(service_fee * quantity)}}
                    </span>
                </li>

                <li class="sm-price-aside-list__item">
                  <span>Delivery</span>
                    <span class="sm-price-aside-list__item--delivery-price">
                      {{formatPrice(deliveryPrice)}}
                    </span>
                </li>

                <li class="sm-price-aside-list__item">
                  <span class="sm-h5">Total to pay</span>
                    <span class="sm-h5 sm-price-aside-list__item--total-price">
                      {{formatPrice(totalPrice)}}
                    </span>
                </li>
              </ul>
            </div>
          </div>

          <btn-block
            v-if="deliveryOptions.length"
            class="sm-group-forwarding__forward-btn"
            :class="{'disabled': !deliveryPrice}"
            :text="'Purchase & print label'"
            @click="forwardMail"
          />
        </template>
        <template v-else>
          
          <div class="sm-group-forwarding__result" >
            <h2>{{isGroup ? 'Group ' : ''}}Mail #{{isGroup ? curItem.id : curItem.mail_number}} is forwarded</h2>
            <p>Please print or save shipping label</p>
            <iframe 
              v-if="curItem.shipping_label.includes('.pdf')"
              :src="curItem.shipping_label" 
              :class="'sm-group-forwarding__result-pdf'"
              width="100%" 
              height="500px"
              @load="showSpinner = false"
            />
            <div 
              v-else
              :class="'sm-group-forwarding__result-png'"
            >
              <img-loader 
                :src="curItem.shipping_label" 
                @load="showSpinner = false;"
              />
            </div>
            <btn-block
              :text="'Return to Mail'"
              @click="$router.push(`mail${isGroup ? '?tab=group' : ''}`)"
            />
          </div>
        </template>

        <span class="sm-group-forwarding__pre-manual">or</span>
        <a
          v-if="!finishForward"
          href="#"
          class="sm-group-forwarding__manual"
          @click.prevent="openPopup('manual')"
        >
          <include-svg :name="'icon-phone-forwarding'" />
          <span>Forward manually</span>
        </a>
      </div>

      <keep-alive>
        <popup-block
          v-if="popup.isOpen"
          :open="popup.isOpen"
          :class="`sm-group-forwarding__popup`"
          @close="popup.isOpen = false;"
        >
          <template slot="popupContent">
            <template v-if="popup.type == 'manual'">
              <h4>Forward manually</h4>
              <input-text
                :label="'Postage amount'"
                :value="formatPrice(postage_amount)"
                @blur="processPriceValue"
              />
              <checkbox-block
                v-model="international_forwarding"
                :text="'International forwarding'"
              />
              <checkbox-block
                v-model="expedited_forward"
                :text="'Expedited forwarding'"
              />
              <btn-block
                :text="'Set as forwarded'"
                @click="manualForward"
              />
            </template>
            <form-address
              v-else-if="popup.type == 'form-edit'"
              :title="'Edit forward address'"
              :btnText="'Change'"
              :notCurrent="true"
              :initData="curFwAddress"
              @submit="updateFwAddress"
            />
            <form-address
              v-else-if="popup.type == 'form-create'"
              :key="`form-create-${formCreateKey}`"
              :title="'Create forward address'"
              :btnText="'Create'"
              :notCurrent="true"
              @submit="createFwAddress"
            />
            <div 
              v-else-if="popup.type == 'select-addr'"
              class="sm-group-forwarding__popup-select"
            >
              <h4>Select Address</h4>
              <dropdown-block
                v-model="selectedFwAddress"
                class="sm-dropdown"
                :options="forwardingAddresses"
                :placeholder="`Forwarding address`"
                :preselect-first="true"
                :allow-empty="false"
              >
                <template slot="singleLabel" slot-scope="props" :value="props.option.id">
                  <span>{{ formatAddress(props.option) }}</span>
                  <include-svg :name="'icon-arrow-b'" />
                </template>
                <template slot="noOptions">
                  <span>Loading...</span>
                </template>
                <template slot="option" slot-scope="props" :value="props.option.id">
                  <span class="sm-txt-capitalize">{{ formatAddress(props.option) }}</span>
                </template>
              </dropdown-block>
              <btn-block
                :type="'submit'"
                :text="`Confirm`"
                @click="setFwAddress"
              />
            </div>
            <div
              v-else-if="popup.type == 'fw-error'"
              class="sm-group-forwarding__popup-error"
            >
              <h4>Can't assign Forwarding address</h4>
              <p>{{backError}}</p>
              <btn-block
                :text="'Ok'"
                @click="popup.isOpen = false"
              />
            </div>
            <div
              v-else-if="popup.type == 'fw-manual-error'"
              class="sm-group-forwarding__popup-error"
            >
              <h4>Can't Forward Mail</h4>
              <p v-html="backError"></p>
              <btn-block
                :text="'Ok'"
                @click="popup.isOpen = false"
              />
            </div>
          </template>
        </popup-block>
      </keep-alive>

      <sm-spinner :show="showSpinner" :isGlobal="true" />
    </template>
    <sm-spinner 
      v-else
      :show="true"
      :isGlobal="true"
    />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs';
import Radiobutton from '@/components/Radiobutton';
import InputText from '@/components/InputText';
import Popup from '@/components/Popup';
import Multiselect from 'vue-multiselect';
import {FormatPrice} from '@/utils/general-data';
import {ProcessInputValue} from '@/utils/input';
import { mapGetters, mapActions } from 'vuex';
import FormAddress from '@/components/forms/FormAddress';
import Spinner from '@/components/Spinner';
import Checkbox from '@/components/Checkboxes';
import {ParseErrorText} from '@/utils/errors';

import PackageTypes from '@/settings/package-types';

import MailForwardingAddresses from '@/views/admin/pages/pages-components/mail-forwarding/Addresses';
import MailForwardingDetails from '@/views/admin/pages/pages-components/mail-forwarding/ParcelDetails';
import MailForwardingPackaging from '@/views/admin/pages/pages-components/mail-forwarding/Packaging';
import ImgLoader from '@/components/ImgLoader';
export default {
  name: 'mail-forwarding',
  components: {
    'breadcrumbs-block': Breadcrumbs,
    'radiobutton-block': Radiobutton,
    'dropdown-block': Multiselect,
    'input-text': InputText,
    'popup-block': Popup,
    'form-address': FormAddress,
    'sm-spinner': Spinner,
    'checkbox-block': Checkbox,
    'img-loader': ImgLoader,
    'mail-forwarding-addresses': MailForwardingAddresses,
    'mail-forwarding-details': MailForwardingDetails,
    'mail-forwarding-packaging': MailForwardingPackaging
  },
  data() {
    return {
      service_fee: 0,

      postage_amount: 0,
      international_forwarding: false,
      expedited_forward: false,

      curItem: null,
      curPMB: null,
      curFwAddress: {},
      forwardingAddresses: [],
      selectedFwAddress: null,
      deliveryServices: [],
      curService: {},
      curLabelSize: "8.5x11",
      curPackage: null,
      deliveryOptions: [],
      selectedOption: null,
      breadcrumbsSingle: [
        {
          link: 'mail',
          text: 'Mail'
        },
        {
          text: 'Forward Mail',
          link: 'mail-forwarding',
          current: true
        }
      ],
      breadcrumbsGroup: [
        {
          link: 'mail?tab=group',
          text: 'Bulk Shipping'
        },
        {
          text: 'Forward Group Mail',
          link: 'group-forwarding',
          current: true
        }
      ],
      popup: {
        isOpen: false,
        type: '' // values: manual, form-edit, form-create, select-addr, fw-error, fw-manual-error
      },
      showSpinner: true,
      ratesRequested: false,
      finishForward: false,
      formCreateKey: 0,
      backError: '',
      noForm: false,
      labelSizes: [
        {name: "8.5x11", desc: "", value: "8.5x11"},
        {name: "4x6", desc: "", value: "4x6"}
      ],
    }
  },
  created() {
    let mail_number = this.$route.query.mail_number;

    if (!mail_number)
      this.$router.push('mail');

    if (this.isGroup) {
      this.showSpinner = true;
      this.getAdminGroupMailItem(mail_number)
        .then(res => {
          if (res.forwarded_date || !res.mail_items.length)
            this.$router.push('mail');
          
          this.curItem = this.prepareGroupMail(res);

          Promise.all([
            this.findPMBs(this.curItem.mail_items[0].account_number),
            this.getForwardingAddresses(this.curItem.mail_items[0].account_id),
            this.getShippingCarriers()
          ])
            .then(([pmbs, fw, shipping_carriers]) => {
              this.showSpinner = false;
              this.curPMB = pmbs.find(item => item.pmb == this.curItem.mail_items[0].account_number);

              shipping_carriers.forEach(item => {
                if (PackageTypes[item.id])
                  item.packages = PackageTypes[item.id].map(type => type.label);
              })

              this.deliveryServices = shipping_carriers;
              this.curService = this.deliveryServices.find(service => !service.disabled);

              if (fw.forward_addresses.length) { // Have fw addresses
                this.forwardingAddresses = fw.forward_addresses;

                if (this.curItem.forward_address_id) { // Fw address already attached to mail
                  this.setAttachedFwAddress(fw.forward_addresses.find(address => address.id == this.curItem.forward_address_id));
                } else { // Fw address not attached to mail
                  if (this.forwardingAddresses.length < 2) { // Have only one fw address => attach it to mail
                    this.setFwAddress();
                  } else { // Have multiple fw addresses => show select
                    this.openPopup('select-addr');
                  }
                } 
              } else { // No fw addresses => show create
                this.openPopup('form-create');
              }
            });
        })

    } else {
      this.showSpinner = true;
      this.getAdminMail(mail_number)
        .then(res => {
          this.curItem = res.mail_item;

          if (!this.curItem || this.curItem.is_forward_complete || !this.curItem.is_active_customer)
            this.$router.push('mail');

          Promise.all([
            this.findPMBs(this.curItem.account_number),
            this.getForwardingAddresses(this.curItem.account_id),
            this.getShippingCarriers()
          ])
            .then(([pmbs, fw, shipping_carriers]) => {
              this.showSpinner = false;
              this.curPMB = pmbs.find(item => item.pmb == this.curItem.account_number);

              shipping_carriers.forEach(item => {
                if (PackageTypes[item.id])
                  item.packages = PackageTypes[item.id].map(type => type.label);
              })

              this.deliveryServices = shipping_carriers;

              if (this.deliveryServices.length)
                this.curService = this.deliveryServices.find(service => !service.disabled);

              if (fw.forward_addresses.length) { // Have fw addresses
                this.forwardingAddresses = fw.forward_addresses;

                if (this.curItem.forward_address_id) { // Fw address already attached to mail
                  this.setAttachedFwAddress(fw.forward_addresses.find(address => address.id == this.curItem.forward_address_id));
                } else { // Fw address not attached to mail
                  if (this.forwardingAddresses.length < 2) { // Have only one fw address => attach it to mail
                    this.setFwAddress();
                  } else { // Have multiple fw addresses => show select
                    this.openPopup('select-addr');
                  }
                } 
              } else { // No fw addresses => show create
                this.openPopup('form-create');
              }
            });
        });
    }
  },
  computed: {
    ...mapGetters({
      provider: 'provider',
      countryList: 'countryList'
    }),
    isGroup() {
      return this.$route.path.indexOf('group') > 0;
    },
    curCountry() {
      return this.countryList.find(country => country.id == this.provider.country_id);
    },
    deliveryPrice() {
      if (!this.selectedOption)
        return 0;

      let split = this.selectedOption.rate.split('$');

      return parseFloat(split[1]) * 100;
    },
    quantity() {
      return this.curItem && !this.isGroup ? this.curItem.quantity : 1;
    },
    totalPrice() {
      return this.service_fee * this.quantity + this.deliveryPrice;
    },
    isDifferentCountry() {
      return this.curCountry.id != this.curFwAddress.country_id;
    },
  },
  methods: {
    ...mapActions({
      getAdminMail: 'mail/getAdminMail',
      findPMBs: 'mail/findPMBs',
      adminMailAction: 'mail/adminMailAction',
      getShippingCarriers: 'shipping/getShippingCarriers',
      getShippingRates: 'shipping/getShippingRates',
      getForwardingAddresses: 'wrappers/getForwardingAddresses',
      setForwardingAddress: 'mail/setForwardingAddress',
      createForwardAddress: 'wrappers/createForwardAddress',
      updateForwardAddress: 'wrappers/updateForwardAddress',
      getAdminGroupMailItem: 'mail/getAdminGroupMailItem',
      getStateList: 'getStateList',
      editMail: 'mail/editMail'
    }),
    formatPrice: FormatPrice,
    findDeliveryOptions(parcelData = {}) {
      let sendData = {
        ...this.curPackage.toSend,
        ...parcelData,
        label_size: this.curLabelSize
      }

      if (this.isGroup)
        sendData.groupmail = true;

      this.showSpinner = true;
      this.ratesRequested = true;

      this.tryUpdateMailWeight(() => {
        this.getShippingRates({
          id: this.curItem.id,
          params: sendData
        })
          .then(res => {
            if (res) {
              this.deliveryOptions = res.rates;
              this.service_fee = res.spheremail_fee;
            }

            this.showSpinner = false;

            window.requestAnimationFrame(() => {
              let elem = this.$el.querySelector('.sm-group-forwarding__delivery');

              if (elem)
                elem.scrollIntoView();
            });
          })
          .catch(e => {
            this.deliveryOptions = [];
            this.service_fee = 0;

            this.showSpinner = false;
          });  
      });
    },
    tryUpdateMailWeight(callback) {
      if (
        !this.isGroup &&
        (
          this.curPackage.weight != this.curItem.weight ||
          this.curPackage.weight_unit != this.curItem.weight_unit  
        )
      ) {
        let formData = new FormData();

        formData.append('mail_item[weight]', this.curPackage.weight);
        formData.append('mail_item[weight_unit]', this.curPackage.weight_unit);

        this.editMail({
          id: this.curItem.id,
          params: formData
        })
          .then(res => {
            callback();
          })
          .catch(e => {
            this.showSpinner = true; // show spinner because error handler hides it
            callback();
          })
      } else {
        callback();
      }
    },
    openPopup(type) {
      this.popup.type = type;
      this.popup.isOpen = true;
    },
    manualForward() {
      this.showSpinner = true;
      this.adminMailAction({
        id: this.curItem.id,
        action: 'forward',
        params: {
          postage_amount: this.postage_amount,
          international_forwarding: this.international_forwarding,
          expedited_forward: this.expedited_forward,
          groupmail: this.isGroup,
        }
      })
        .then(res => {
          this.$router.push('mail');
          this.showSpinner = false;
        })
        .catch(e => {
          console.log(e, e.response);

          let err = e.response;

          if (err && err.data && err.data.errors) {
            this.backError = ParseErrorText(err.data.errors);
            this.popup.type = 'fw-manual-error';
            this.popup.isOpen = true;
          }

          this.showSpinner = false;
        });
    },
    prepareAddress(item) {
      let country = this.countryList.find(country => country.id == item.country_id);

      return {
        ...item,
        country: country,
        state: item.state_id ? country.states.find(state => state.id == item.state_id) : null
      };
    },
    processPriceValue(e) {
      this.postage_amount = ProcessInputValue(e, 'price');
    },
    createFwAddress(formData) {
      this.formCreateKey++;
      this.showSpinner = true;

      this.createForwardAddress({
        id: this.curItem.account_id,
        params: formData
      })
        .then(res => {
          this.getForwardingAddresses(this.curItem.account_id)
            .then(fw => {
              this.forwardingAddresses = fw.forward_addresses;
              this.setFwAddress(res.forward_address.id);
              this.popup.isOpen = false;
              this.showSpinner = false;
            })
            .catch(e => {
              console.log(e, e.response);
              this.showSpinner = false;
            });
        })
        .catch(e => {
          let err = e.response;

          if (
            err &&
            err.data &&
            err.data.errors &&
            err.data.errors.base
          ) {
            this.backError = err.data.errors.base[0];
            this.popup.type = 'fw-error';
            this.popup.isOpen = true;
          } else {
            this.popup.isOpen = false;
          }
          
          this.showSpinner = false;
        });
    },
    updateFwAddress(data) {
      this.showSpinner = true;

      if (!data.state_id) // TEMP, backend issue
          data.state_id = 1;

      if (!this.curItem.account_id) { // Group fwd
        this.curItem.account_id = this.curItem.mail_items[0].account_id;
      }
      
      this.updateForwardAddress({
        addr_id: this.curFwAddress.id,
        customer_id: this.curItem.account_id,
        params: data
      })
        .then(res => {
          this.getForwardingAddresses(this.curItem.account_id)
            .then(fw => {
              this.forwardingAddresses = fw.forward_addresses;
              this.curFwAddress = this.prepareAddress(this.forwardingAddresses.find(addr => addr.id == this.curFwAddress.id));
              this.popup.isOpen = false;
              this.showSpinner = false;
            })
        })
        .catch(e => {
          let err = e.response;

          if (
            err &&
            err.data &&
            err.data.errors &&
            err.data.errors.base
          ) {
            this.backError = err.data.errors.base[0];
            this.popup.type = 'fw-error';
            this.popup.isOpen = true;
          } else {
            this.popup.isOpen = false;
          }
          
          this.showSpinner = false;
        })
    },
    setFwAddress(fwAddrId) {
      this.showSpinner = true;

      if (!fwAddrId)
        fwAddrId = this.popup.isOpen && this.popup.type == 'select-addr' ? this.selectedFwAddress.id : this.forwardingAddresses[0].id;

      let sendData = {
        forward_address_id: fwAddrId
      }

      if (this.isGroup)
        sendData.groupmail = true;

      this.setForwardingAddress({
        id: this.curItem.id,
        params: sendData
      })
        .then(res => {
          this.curFwAddress = this.prepareAddress(this.forwardingAddresses.find(addr => addr.id == fwAddrId));
          this.curItem = this.isGroup ? res : res.mail_item;
          this.popup.isOpen = false;
          this.showSpinner = false;
        })
        .catch(e => {
          console.log(e, e.response);
          let err = e.response;

          if (err && err.data && err.data.errors) {
            this.backError = ParseErrorText(err.data.errors);
            this.popup.type = 'fw-error';
            this.popup.isOpen = true;

            // TEMP
            if (this.backError == 'USPS Form 1583 Unsigned.')
              this.noForm = true;
          }

          this.popup.isOpen = false;
          this.showSpinner = false;
        });
    },
    setAttachedFwAddress(item) {
      let country = this.countryList.find(country => country.id == item.country_id);
      
      if (item.state_id && !country.states) {
        this.showSpinner = true;
        this.getStateList(country.id)
          .then(states => {
            this.curFwAddress = {
              ...item,
              country: country,
              state: states.find(state => state.id == item.state_id)
            };
            this.showSpinner = false;
          });
      } else {
        this.curFwAddress = {
          ...item,
          country: country,
          state: item.state_id ? country.states.find(state => state.id == item.state_id) : null
        };
      }
    },
    formatAddress(item) {
      let res = '';

      if (item.street)
        res += `${item.street}, `;

      if (item.city)
        res += `${item.city}, `;

      if (item.zip_code)
        res += `${item.zip_code}, `;

      if (item.country_id) {
        let addrCountry = this.countryList.find(country => country.id == item.country_id);
        res += addrCountry.code;
      }

      return res;
    },
    showSelectAddr() {
      if (!this.selectedFwAddress && this.curFwAddress)
        this.selectedFwAddress = this.forwardingAddresses.find(addr => addr.id == this.curFwAddress.id);

      this.openPopup('select-addr');
    },
    forwardMail() {
      this.showSpinner = true;
      let sendData = {
        shipment_id: this.selectedOption.shipment_id,
        rate_id: this.selectedOption.id,
        expedited_forward: this.selectedOption.delivery_days ? true : false,
        international_forwarding: this.isDifferentCountry,
        carrier_id: this.curService.id,
      }

      if (this.isGroup)
        sendData.groupmail = true;

      this.adminMailAction({
        id: this.curItem.id,
        action: 'forward_by_shipment',
        params: sendData
      })
        .then(res => {
          this.curItem = this.isGroup ? res : res.mail_item;
          this.finishForward = true;
          // this.$router.push('mail');
          this.showSpinner = false;
        })
        .catch(e => {
           console.log(e, e.response);

          let err = e.response;

          if (err && err.data && err.data.errors) {
            const unprocessableErr = 'The request could not be understood by the server due to malformed syntax.'
            const desiredFirstClassError =  "First-Class International shipping is unavailable for this item. Please select a different delivery option or carrier."
            const firstClassErrorURL = "https://support.spheremail.co/support/solutions/articles/69000848737-why-can-t-i-forward-mail-internationally-with-usps-"

            this.backError = (ParseErrorText(err.data.errors) == unprocessableErr && this.curService.id == "usps" && this.isDifferentCountry) ? `<a href="${firstClassErrorURL}" target="_blank">Due to USPS restrictions, </a>${desiredFirstClassError}` : ParseErrorText(err.data.errors)

            // this.backError = ParseErrorText(err.data.errors);
            this.popup.type = 'fw-manual-error';
            this.popup.isOpen = true;
          }

          this.showSpinner = false;
        });
    },
    prepareGroupMail(item) {
      return {
        ...item,
        account_id: item.mail_items[0].account_id,
        account_number: item.mail_items[0].account_number
      }
    },
    findInternationalRates(data) {
      this.findDeliveryOptions(data);
    }
  },
  watch: {
    curFwAddress: {
      deep: true,
      handler(val) {
        this.deliveryOptions = [];
        this.ratesRequested = false;
        this.service_fee = 0;
        this.selectedOption = null;
      }
    },
    finishForward(val) {
      if(val) this.showSpinner = true;
    },
  }
}
</script>

<style lang="scss">
  @use '@/assets/scss/general/mixins.scss' as *;
  @use '@/assets/scss/framework/scss-variables.scss' as *;
  @use '@/assets/scss/pages/common/_mail-forwarding.scss';
</style>
